<template>
  <div class="testimonial-container mx-auto py-12 px-8 h-[420px] bg-pink-900">
    <!-- Text content -->
    <div class="text-center">
      <h2 class="text-3xl sm:text-4xl text-white font-serif mb-6">Love Letters from Our Customers</h2>
      <p class="text-md lg:max-w-2xl max-w-4xl sm:max-w-xl md:max-w-xl lg:max-w-4xl text-white mb-6 mx-auto">
        Here’s what some of our wonderful brides and grooms have to say about their experience with us.
      </p>

      <!-- Carousel for testimonials with direct transitions -->
      <div class="testimonial-content max-w-sm sm:max-w-lg md:max-w-xl lg:max-w-2xl mx-auto relative">
        <div
          v-for="(testimonial, index) in testimonials"
          :key="index"
          class="testimonial-item"
          :class="{ 'active': currentIndex === index, 'inactive': currentIndex !== index }"
        >
          <p class="text-sm sm:text-sm md:text-sm lg:text-lg text-white italic ">{{ testimonial.text }}</p>
          <div class="mt-4">
            <p class="font-semibold text-white">{{ testimonial.name }}</p>
            <p class="text-sm text-white">{{ testimonial.role }}</p>
          </div>
        </div>
      </div>

      <!-- Navigation buttons -->
      <div class="navigation top-1/2 transform -translate-y-1/2 left-0 right-0 flex justify-between w-[80%] mx-auto z-10">
        <button
          @click="previousTestimonial"
          class="text-white text-xl sm:text-lg md:text-xl px-3 sm:px-4 py-1 sm:py-2 rounded-full bg-pink-700 hover:bg-pink-600 transition"
        >
          &lt;
        </button>
        <button
          @click="nextTestimonial"
          class="text-white text-xl sm:text-lg md:text-xl px-3 sm:px-4 py-1 sm:py-2 rounded-full bg-pink-700 hover:bg-pink-600 transition"
        >
          &gt;
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import testimonialsData from '../data/testimonials.json';

export default {
  name: 'TestimonialSection',

  data() {
    return {
       testimonials: testimonialsData,
     
      currentIndex: 0,
    };
  },

  methods: {
    previousTestimonial() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = this.testimonials.length - 1;
      }
    },
    nextTestimonial() {
      if (this.currentIndex < this.testimonials.length - 1) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0;
      }
    },
  },
};
</script>


<style scoped>
.testimonial-container {
  position: relative;
}

.testimonial-content {
  position: relative;
}

.testimonial-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  transform: translateX(-10px);
  transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
}

.testimonial-item.active {
  opacity: 1;
  transform: translateX(0);
}

.testimonial-item.inactive {
  opacity: 0;
  transform: translateX(-10px);
}

button {
  font-size: 1.5rem;
  z-index: 10;
}

/* Navigation buttons adjustments */
.navigation {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  width: 50%;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}

/* Responsive Height Adjustments */
@media (max-width: 1800px) {
  .navigation {
    width: 70%;
  }
}

@media (max-width: 1024px) {
  .navigation {
    width: 95%;
  }
}


@media (max-width: 639px) {
 .testimonial-container {
    height: 450px; /* Very small screen sizes */
  }
}

@media (max-width: 480px) {
  .testimonial-container {
    height: 560px; /* Very small screen sizes */
  }

  .navigation {
    bottom: 20px; /* Move to the bottom of the container */
    top: auto; /* Remove top positioning */
    transform: none; /* Remove translation */
    width: 40%;
  }
}

</style>
